(() => {
  function initialize() {
    document.querySelectorAll('.tsj-inquiry').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const params = new URL(location.href).searchParams;
      const select = form.querySelector('[data-topic]');
      const title = (params.get('tsd_product') || '').replace(/[\r\n]/g, ' ').slice(0, 240);
      const requested = params.get('topic') || (title ? 'blade' : 'general');
      const match = Array.from(select.options).find(option => option.dataset.key === requested);
      if (match) select.value = match.value;
      function update() {
        const option = select.selectedOptions[0];
        form.querySelector('[data-topic-hint]').textContent = option.dataset.hint;
        form.querySelectorAll('[data-topics]').forEach(group => {
          const visible = group.dataset.topics.split(' ').includes(option.dataset.key);
          group.hidden = !visible;
          group.querySelectorAll('input,select').forEach(input => input.disabled = !visible);
        });
        form.querySelector('[name="contact[Inquiry source]"]').value = title ? 'TSD website: ' + title : 'TSD website inquiry';
      }
      select.addEventListener('change', update);
      update();
      const body = form.querySelector('textarea');
      if (title && !body.value.trim()) body.value = title + '\n\n';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
